import {IPropertyTypeConfig} from '@mintdata/mint-kit/api/properties/PropertyTypeConfig';
import {BeanConverter} from '@mintdata/mint-kit/impl/properties/converters/BeanConverter';
import {ArrayEditor} from '@mintdata/mint-kit/impl/properties/editors/ArrayEditor';

export const ArrayConfig:IPropertyTypeConfig<any> =
    {
        converter: BeanConverter,
        editor: ArrayEditor,
        isArray: true,
    };

export function getArrayConfig(typeConfig:IPropertyTypeConfig<any>):IPropertyTypeConfig<any>
{
    return {
        ...typeConfig,
        isArray: true,
    };
}
